import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import NotificationSystem from "react-notification-system";

import {
  Button,
  Grid,
  Table,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Modal,
  Alert,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";
import {
  GetAllLightHouseTemplates,
  addLightHouseTemplate,
  getTemplateById,
  updateLightHouseTemplate,
  deleteLightHouseTemplate,
} from "Listfunction";
import Swal from "sweetalert2";
import { LoginLightHouse } from "Listfunction";

const ViewLightHouseTemplate = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [templateList, setTemplateList] = useState();
  const [addTemplateModalShow, setAddTemplateModalShow] = useState(false);
  const [templateType, setTemplateType] = useState("Home Screen");
  const [templateTitle, setTemplateTitle] = useState();
  const [templateBody, setTemplateBody] = useState();
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [templateId, setTemplateId] = useState();
  const [typeError, setTypeError] = useState(null);
  const [titleeError, setTitleError] = useState(null);
  const [bodyError, setBodyError] = useState(null);
  const [templateDataById, setTemplateDataById] = useState();
  const [typeId, setTypeId] = useState();

  let LgtToken = localStorage.getItem("lightHouseToken");

  useEffect(() => {
    setLoading(true);

    const loginCredentials = {
      email: "umar@gmail.com",
      password: "12345",
    };

    GetAllLightHouseTemplates(LgtToken, currentPage)
      .then((res) => {
        setCurrentPage(res.data.first_page_url);
        setTotalPage(res.data.last_page);
        setTemplateList(res.data.data);
        setLoading(false);
      })
      .catch(async (err) => {
        if (err.response.status === 401) {
          const res = await LoginLightHouse(loginCredentials);
          localStorage.setItem("lightHouseToken", res.data.token);
        } else {
          console.log(err);
        }
      });
  }, []);

  const handletemplateTypeOnchange = (e) => {
    setTypeError(null);
    setTemplateType(e.target.value);
  };
  const handletemplateTitleOnchange = (e) => {
    setTitleError(null);
    setTemplateTitle(e.target.value);
  };
  const handletemplateBodyOnchange = (e) => {
    setBodyError(null);
    setTemplateBody(e.target.value);
  };

  const handleAddTemplateSubmit = async () => {
    if (templateTitle === undefined) {
      setTitleError(
        <div class="alert alert-danger" role="alert">
          Title is Required
        </div>
      );
    } else if (templateBody === undefined) {
      setBodyError(
        <div class="alert alert-danger" role="alert">
          Body is Required
        </div>
      );
    }
    // }
    else if (!isUpdateModal) {
      setBodyError(null);
      setBodyError(null);
      const addTemplateBody = {
        type_id: 33,
        type_name: "Home Screen",
        title: templateTitle,
        body: templateBody,
      };
      const notification = _notificationSystem.current;
      try {
        const res = await addLightHouseTemplate(addTemplateBody, LgtToken);
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Template</b> - Created Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setAddTemplateModalShow(false);

          GetAllLightHouseTemplates(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const templates = res.data.data;
              setTemplateList(templates);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log("err", err);
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } else {
      setBodyError(null);
      setTypeError(null);
      setTitleError(null);
      const updateLightHouseTemplateBody = {
        type_id: 33,
        type_name: "Home Screen",
        title: templateTitle,
        body: templateBody,
      };
      const notification = _notificationSystem.current;
      try {
        const res = await updateLightHouseTemplate(
          updateLightHouseTemplateBody,
          templateId,
          LgtToken
        );
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Template</b> - Updated Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setAddTemplateModalShow(false);

          GetAllLightHouseTemplates(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const templates = res.data.data;
              setTemplateList(templates);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (err) {
        console.log("err", err);
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };

  const openEditCategoryModal = (id) => {
    setAddTemplateModalShow(true);
    setIsUpdateModal(true);
    setBodyError(null);
    setTitleError(null);
    setTemplateId(id);
    getTemplateById(LgtToken, id)
      .then((res) => {
        const templates = res.data;
        setTemplateDataById(templates);
        setTemplateTitle(res.data.title);
        setTemplateBody(res.data.body);
        setTemplateType(res.data.type_name);
        setTypeId(res.data.type_id);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAddCaddCategoryButtonClick = () => {
    setAddTemplateModalShow(true);
    setIsUpdateModal(false);
    setTemplateTitle(undefined);
    setTemplateType(undefined);
    setTemplateBody(undefined);
    setTitleError(null);
    setBodyError(null);
  };

  const handleRemoveClick = (id) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to remove this template </font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const notification = _notificationSystem.current;
        const res = await deleteLightHouseTemplate(LgtToken, id);
        if (res.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>Template</b> - Removed Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          setLoading(true);
          GetAllLightHouseTemplates(LgtToken, currentPage)
            .then((res) => {
              setCurrentPage(res.data.first_page_url);
              setTotalPage(res.data.last_page);
              const templates = res.data.data;
              setTemplateList(templates);
              setLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    });
  };

  const paginationOnChange = async (LgtToken, number) => {
    setLoading(true);
    const res = await GetAllLightHouseTemplates(LgtToken, number);

    setTemplateList(res.data.data);
    setCurrentPage(res.data.current_page);
    setTotalPage(res.data.last_page);
    setLoading(false);
  };

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => paginationOnChange(LgtToken, number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  const subCategory = <Tooltip id="remove">Sub Category</Tooltip>;
  const remove = <Tooltip id="remove">Remove</Tooltip>;
  const edit = <Tooltip id="edit">Edit</Tooltip>;

  return (
    <>
      <Grid fluid>
        <Col xs={12} sm={12} md={12} lg={12}>
          <NotificationSystem ref={_notificationSystem} />
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} className="text-left">
              <FormControl
                style={{ position: "relative", marginTop: "25px" }}
                name="search"
                //   value={searchParam}
                placeholder="Search"
                //   onChange={(event) => handleSearch(event)}
                type="text"
                className="text-input"
              />
            </Col>
            <Col xs={2} sm={2} md={2} lg={2} className="text-left">
              <Button
                style={{ marginTop: "25px" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              >
                Reset
              </Button>
            </Col>
            <Col xs={6} sm={6} md={6} lg={6} className="text-right">
              <Button
                style={{ marginTop: "25px" }}
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                onClick={() => handleAddCaddCategoryButtonClick()}
              >
                Add Template <i className="fa fa-plus"></i>
              </Button>
              <br />
              &nbsp;
            </Col>
          </Row>
        </Col>
        <br />
        <Col md={12} xs={12} sm={12}>
          <Card
            content={
              <>
                <React.Fragment>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Template</th>
                        <th>Screen Link</th>
                        <th>Content</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td>
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : noRecordFound ? (
                        <tr>
                          <td colspan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {templateList &&
                            templateList.map((item, i) => (
                              <>
                                <tr>
                                  <td>{item.id}</td>
                                  <td>{item.title}</td>
                                  <td>{item.type_name}</td>
                                  <td>{item.body}</td>
                                  <td className="td-actions text-right no-padding">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple
                                        bsStyle="info"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                          openEditCategoryModal(item.id);
                                        }}
                                      >
                                        <i class="fa fa-pencil" />
                                      </Button>
                                    </OverlayTrigger>
                                    &nbsp;
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={remove}
                                    >
                                      <Button
                                        simple
                                        bsStyle="danger"
                                        bsSize="xs"
                                        style={{ border: "none" }}
                                        onClick={() => {
                                          handleRemoveClick(item.id);
                                        }}
                                      >
                                        <i class="fa fa-times" />
                                      </Button>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              </>
                            ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination bsSize="medium">{items}</Pagination>
                  </div>
                </React.Fragment>
              </>
            }
          />
        </Col>
      </Grid>
      <Modal
        show={addTemplateModalShow}
        onHide={() => setAddTemplateModalShow(false)}
        bsSize="large"
        allowFullScreen
      >
        <Modal.Header>
          <Modal.Title>
            {" "}
            {isUpdateModal ? "Edit Template" : "Add Template"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Screen Link</ControlLabel>
              <FormGroup>
                <FormControl
                  disabled
                  type="text"
                  value="Home Screen"
                  name="type"
                  placeholder="Enter the Type name "
                  onChange={(e) => handletemplateTypeOnchange(e)}
                />
              </FormGroup>
              {typeError}
            </Col>
          </Row>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Title</ControlLabel>
              <FormGroup>
                <FormControl
                  type="text"
                  value={templateTitle}
                  name="title"
                  placeholder="Enter the template Title "
                  onChange={(e) => handletemplateTitleOnchange(e)}
                />
              </FormGroup>
              {titleeError}
            </Col>
          </Row>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Body</ControlLabel>
              <FormGroup>
                <textarea
                  className="form-control"
                  rows="4"
                  cols="5"
                  name="Body"
                  value={templateBody}
                  onChange={(e) => handletemplateBodyOnchange(e)}
                />{" "}
              </FormGroup>
              {bodyError}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="danger"
            fill
            onClick={() => setAddTemplateModalShow(false)}
          >
            Cancel
          </Button>
          <Button
            bsStyle="success"
            fill
            onClick={() => handleAddTemplateSubmit()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewLightHouseTemplate;
